$(function(){
  $('.scrollShow').css('visibility','hidden');
  $(window).scroll(function(){
    var h = $(window).height(),
        ypx = $(window).scrollTop();
    $('.scrollShow').each(function(){
      var targetPosition = $(this).offset().top;
      if (ypx > targetPosition - h + 100) {
        $(this).addClass('animated bounceInUp');
      }
    });
  });
});
